module.exports = __webpack_public_path__ + "static/ottos-43da2707fee7b406ea07158949507419.png";